import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import { SearchBar } from '../';
import { useProfile } from '@/hooks';

interface Props {
  onSearch?: (value: string) => void;
  joinRequests?: boolean;
  invites?: boolean;
}

export default function GuildNavigation({ onSearch = () => null, joinRequests, invites }: Props) {
  const { t } = useTranslation();
  const location = useLocation();
  const {
    profile: { clan },
  } = useProfile();

  const linkCls = React.useCallback(
    ({ isActive }: { isActive: boolean }) =>
      classNames(
        'flex flex-1 lg:flex-initial justify-center text-sm rounded-md text-blue-500 py-1.5 px-4',
        isActive
          ? 'bg-blue-50 dark:bg-[#FFDA68]/30 dark:text-[#151515]'
          : 'hover:opacity-100 dark:text-[#FFDA68]',
      ),
    [],
  );

  return (
    <div className='flex flex-col-reverse flex-1 w-full lg:w-auto gap-y-2 lg:flex-row items-center lg:justify-end lg:gap-x-4'>
      <SearchBar onDebouncedUpdate={onSearch} className='w-full lg:max-w-xs mx-auto' />

      {location.pathname === '/clans' && (
        <nav className='flex gap-x-2 w-full lg:w-max whitespace-nowrap'>
          {!clan || !clan?.id ? (
            <>{/* <div className={linkCls({ isActive: false })}>{t('My Clan')}</div> */}</>
          ) : (
            <>
              <NavLink to={'/clans/' + clan?.id} className={linkCls}>
                {t('My Clan')}
              </NavLink>
            </>
          )}

          {joinRequests && (
            <NavLink
              to={clan?.id ? `/clans/${clan.id}/join-requests` : '/clans/join-requests'}
              className={linkCls}
            >
              {t('Applications')}
            </NavLink>
          )}

          {invites && (
            <NavLink
              to={clan?.id ? `/clans/${clan.id}/invites` : '/clans/invites'}
              className={linkCls}
            >
              {t('Invites')}
            </NavLink>
          )}

          <NavLink to='/clans' end className={linkCls}>
            {t('All Clans')}
          </NavLink>
        </nav>
      )}
    </div>
  );
}
